// Catalog kind is assigned by the API from source identity, never item names.
const KINDS = new Set(["fish", "dried", "item"]);

export function catalogKind(entry) {
  if (!KINDS.has(entry?.catalog_kind)) {
    throw new TypeError("Fishydex catalog_kind must be fish, dried, or item");
  }
  return entry.catalog_kind;
}

export function selectCatalogItems(entries, { includeNonFish = false, includeDried = false } = {}) {
  return entries.filter(entry => {
    const kind = catalogKind(entry);
    return kind === "item" ? includeNonFish : kind === "dried" ? includeDried : true;
  });
}

export function selectFishProgressItems(entries) {
  return entries.filter(entry => catalogKind(entry) !== "item");
}

// Source filenames may contain named stems and numbered variants, not just item IDs.
export function catalogIconPath(value, label = "Fishydex icon") {
  if (typeof value !== "string" || !/^\/images\/items\/[A-Za-z0-9._-]+\.webp$/.test(value)) {
    throw new TypeError(`${label} must be a normalized item image path`);
  }
  return value;
}
